/**
 * 対話フォームで使用する定数
 */

/**
 * 回答プレフィックスの正規表現パターン
 * 任意のアルファベット1文字以上とコロンの組み合わせを認識
 * 例: a:, b:, ab:, abc: など
 */
export const ANSWER_PREFIX_PATTERN = new RegExp(`^([a-z]+):`, 'i')

/**
 * プレフィックスを抽出する関数
 *
 * @param str 処理する文字列
 * @returns プレフィックス（a, b, c, ab, bcなど）または null
 */
export function extractPrefix(str: string): string | null {
  if (!str) return null
  const match = str.match(ANSWER_PREFIX_PATTERN)
  return match ? match[1].toLowerCase() : null
}

/**
 * プレフィックスを削除する関数
 *
 * @param str 処理する文字列
 * @returns プレフィックスが削除された文字列
 */
export function removePrefix(str: string): string {
  return str.replace(ANSWER_PREFIX_PATTERN, '')
}
